/** @jsxRuntime classic */

export default function ToggleFavorite({
  isToggled,
  onClick,
  onDark = false,
  variant = 'large',
  ...rest
}) {
  return null;
}
